import User from 'types/User';

export default function useUser(): User {
  return global.__AT_STORE__.user;
}
